import React, { useEffect } from 'react';
import StructuredData from '../StructuredData';
import { seoConfig } from 'utils/seoConfig';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  structuredData?: any;
}

const SEOHead: React.FC<SEOHeadProps> = ({
  title = 'Clube da 42 - Cervejas Artesanais por Assinatura',
  description = 'Descubra cervejas artesanais únicas todo mês com o Clube da 42. Assinatura mensal de cervejas selecionadas da Avenida 42 e outras cervejarias independentes.',
  keywords = 'cerveja artesanal, clube de cerveja, assinatura cerveja, cervejaria 42',
  image = '/logo_42.jpg',
  url = seoConfig.site.url,
  type = 'website',
  structuredData,
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }

    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', keywords);
    }

    // Update Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', title);
    }

    const ogDescription = document.querySelector(
      'meta[property="og:description"]',
    );
    if (ogDescription) {
      ogDescription.setAttribute('content', description);
    }

    const ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage) {
      ogImage.setAttribute('content', `${url}${image}`);
    }

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', url);
    }

    const ogType = document.querySelector('meta[property="og:type"]');
    if (ogType) {
      ogType.setAttribute('content', type);
    }

    // Update Twitter tags
    const twitterTitle = document.querySelector(
      'meta[property="twitter:title"]',
    );
    if (twitterTitle) {
      twitterTitle.setAttribute('content', title);
    }

    const twitterDescription = document.querySelector(
      'meta[property="twitter:description"]',
    );
    if (twitterDescription) {
      twitterDescription.setAttribute('content', description);
    }

    const twitterImage = document.querySelector(
      'meta[property="twitter:image"]',
    );
    if (twitterImage) {
      twitterImage.setAttribute('content', `${url}${image}`);
    }

    // Update canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', url);
    }
  }, [title, description, keywords, image, url, type]);

  return (
    <>
      {structuredData && (
        <StructuredData type={structuredData['@type']} data={structuredData} />
      )}
    </>
  );
};

export default SEOHead;
